// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__zW-4I","modal_error":"styles_modal_error__dKOVV","modal__actions":"styles_modal__actions__TSGg-"};